export const CLINICAL_HUD4_TEACHING_PATH = "/clinical-hud-4";

export function clinicalHud4TeachingSessionPath(sessionId) {
  return `${CLINICAL_HUD4_TEACHING_PATH}/case/${sessionId}`;
}
